import * as z from "zod";
import { mutator } from "./mutator";

// Nothing reads this setting any more; the mutation stays callable until
// clients that still offer it have drained, then it is retired.
export const setWorkflowDraftVolumeSeed = mutator({
  schema: z.object({
    workflowId: z.string(),
    draftVolumeSeed: z.enum(["ask", "copy", "empty"]),
  }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  description:
    "Sets whether a workflow’s new drafts ask about, copy, or skip live’s stored data.",
  interactionType: "update",
  fn: async ({ tx, args: { workflow, draftVolumeSeed } }) => {
    await tx.mutate.workflows.update({
      id: workflow.id,
      draftVolumeSeed,
      updatedAt: Date.now(),
    });
  },
});
